import { render, staticRenderFns } from "./ivr-limits-settings.vue?vue&type=template&id=57f74fb0"
import script from "./ivr-limits-settings.vue?vue&type=script&lang=js"
export * from "./ivr-limits-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports